import { saveGroupRequest } from "./actionCreators";
import {
  GroupsAction,
  LOAD_GROUPS,
  LOAD_GROUPS_SUCCESS,
  ADDING_GROUP,
  ADD_GROUP,
  ADD_GROUP_FAIL,
  ADD_GROUP_SUCCESS,
  SAVE_GROUP,
  SAVE_GROUP_FAIL,
  SAVE_GROUP_SUCCESS,
  END_ACTION,
  VALIDATE_FORM_ERROR,
  EDITING_GROUP_FORM,
  EDITING_GROUP,
} from "./actionTypes";

// Other constants
export const ADD_MODAL_DATA = {
  title: "Add Group",
  submitText: "Add Group",
  submitStyle: "success",
};

export const EDIT_MODAL_DATA = {
  title: "Edit Group",
  submitText: "Save Changes",
  submitStyle: "success",
};

const INITIAL_GROUP_FORM_DATA = {};

export interface GroupData {
  group_id?: string;
  group_type?: string;
  group_name?: string;
  group_key?: string | null;
  project?: string | null;
}

interface GroupsState {
  groups: any[];
  projects: {
    [key: string]: any; // @TODO
  };
  users_loaded: boolean;
  adding: boolean;
  editing: boolean;
  working: boolean;
  group_form_data: GroupData;
  user_form_data?: any; // @TODO
  modal_data: any; // @TODO
  success: string | null;
  project_added: boolean;
  project_edited: boolean;
  submit_func?: any; // @TODO
  error?: string | null;
}

const initialState: GroupsState = {
  groups: [],
  projects: {},
  users_loaded: false,
  adding: false,
  editing: false,
  working: false,
  group_form_data: INITIAL_GROUP_FORM_DATA,
  modal_data: {},
  success: null,
  project_added: false,
  project_edited: false,
};

export function reducer(
  state = initialState,
  action: GroupsAction
): GroupsState {
  switch (action.type) {
    case LOAD_GROUPS:
      return {
        ...state,
      };
    case LOAD_GROUPS_SUCCESS:
      return {
        ...state,
        groups: action.result,
        error: null,
      };
    case ADDING_GROUP:
      return {
        ...state,
        adding: true,
        modal_data: ADD_MODAL_DATA,
        success: null,
      };

    case ADD_GROUP:
      return {
        ...state,
        working: true,
      };
    case ADD_GROUP_FAIL:
      return {
        ...state,
        adding: true,
        working: false,
        // TODO: This is a catchall, need to improve error handling.
        error: `${
          action.error.message || action.error.error
        } - The selected Group Name likely already exists in Bonfire`,
      };
    case ADD_GROUP_SUCCESS: {
      const groups = [...state.groups];

      const newGroup = {
        group_id: state.group_form_data.group_key, // NOTE: This id is temporary to avoid `unique key` warning
        group_type: state.group_form_data.group_type,
        group_name: state.group_form_data.group_name,
        group_key: state.group_form_data.group_key,
        project: state.group_form_data.project,
      };

      groups.unshift(newGroup);
      const projectAdded = newGroup.group_type === "project";

      return {
        ...state,
        error: null,
        adding: false,
        working: false,
        groups,
        group_form_data: INITIAL_GROUP_FORM_DATA,
        success: `Group **${state.group_form_data.group_name}** is added successfully.`,
        project_added: projectAdded,
      };
    }
    case SAVE_GROUP:
      return {
        ...state,
        working: true,
      };
    case SAVE_GROUP_FAIL:
      return {
        ...state,
        editing: false,
        working: false,
        error: action.error.message || action.error.error,
      };
    case SAVE_GROUP_SUCCESS: {
      const groups = [...state.groups];

      const groupIndex = groups.findIndex(
        (group) => group.group_id === state.group_form_data.group_id
      );
      groups.splice(groupIndex, 1, state.group_form_data);

      return {
        ...state,
        error: null,
        editing: false,
        working: false,
        groups,
        user_form_data: INITIAL_GROUP_FORM_DATA,
        success: `Changes to Group **${state.group_form_data.group_name}** is successfully saved.`,
      };
    }
    case EDITING_GROUP:
      return {
        ...state,
        editing: true,
        modal_data: EDIT_MODAL_DATA,
        group_form_data: action.row,
        submit_func: saveGroupRequest,
        success: null,
      };
    case EDITING_GROUP_FORM: {
      const groupFormData = { ...state.group_form_data };
      groupFormData[action.input_id] = action.input_value;

      if (
        action.input_id === "group_type" &&
        action.input_value === "project"
      ) {
        groupFormData.project = null;
      }
      if (action.input_id === "group_type" && action.input_value === "site") {
        groupFormData.group_key = null;
      }
      if (action.input_id === "group_type" && action.input_value === "group") {
        groupFormData.project = null;
        groupFormData.group_key = null;
      }

      return {
        ...state,
        group_form_data: groupFormData,
      };
    }
    case END_ACTION:
      return {
        ...state,
        editing: false,
        adding: false,
        group_form_data: INITIAL_GROUP_FORM_DATA,
        error: null,
      };
    case VALIDATE_FORM_ERROR:
      return {
        ...state,
        error: action.error.join("<br>"),
      };

    default:
      return state;
  }
}
